import { Menu } from "@mui/material";
import NotificationsList from "./NotificationMenuList";
import { Broadcast } from "types/broadcast";

const NotificationsMenu = ({
  notifications,
  anchorElement,
  onClose,
}: {
  notifications: Broadcast[];
  anchorElement: HTMLElement | null;
  onClose: () => void;
}) => {
  return (
    <Menu
      keepMounted
      open={Boolean(anchorElement)}
      onClose={onClose}
      anchorEl={anchorElement}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      sx={{ mt: 5, maxWidth: "420px" }}
    >
      <NotificationsList notifications={notifications} onClick={onClose} />
    </Menu>
  );
};

export default NotificationsMenu;
